'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _importCssVariables = require('@brandwatch/axiom-materials/dist/importCssVariables');

var _importCssVariables2 = _interopRequireDefault(_importCssVariables);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

require('./globals.css');

require('./Base.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _importCssVariables2.default)();


var underlineTextSizes = new Set(['display2', 'display1', 'headline', 'body']);

var Base = function (_Component) {
  _inherits(Base, _Component);

  function Base() {
    _classCallCheck(this, Base);

    return _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).apply(this, arguments));
  }

  _createClass(Base, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          Component = _props.Component,
          className = _props.className,
          cloak = _props.cloak,
          cloakContainer = _props.cloakContainer,
          container = _props.container,
          hiddenUntil = _props.hiddenUntil,
          pointerEventsDisabled = _props.pointerEventsDisabled,
          space = _props.space,
          sticky = _props.sticky,
          textBreak = _props.textBreak,
          textCase = _props.textCase,
          textCenter = _props.textCenter,
          textColor = _props.textColor,
          textEllipsis = _props.textEllipsis,
          textEmphasize = _props.textEmphasize,
          textLeft = _props.textLeft,
          textSize = _props.textSize,
          textRight = _props.textRight,
          textStrike = _props.textStrike,
          textStrong = _props.textStrong,
          textUnderline = _props.textUnderline,
          theme = _props.theme,
          visibleUntil = _props.visibleUntil,
          baseRef = _props.baseRef,
          rest = _objectWithoutProperties(_props, ['Component', 'className', 'cloak', 'cloakContainer', 'container', 'hiddenUntil', 'pointerEventsDisabled', 'space', 'sticky', 'textBreak', 'textCase', 'textCenter', 'textColor', 'textEllipsis', 'textEmphasize', 'textLeft', 'textSize', 'textRight', 'textStrike', 'textStrong', 'textUnderline', 'theme', 'visibleUntil', 'baseRef']);

      var underline = textUnderline && underlineTextSizes.has(textSize || 'body') && (textSize || 'body');
      var classes = (0, _classnames3.default)(className, (_classnames = {
        'ax-cloak': cloak !== undefined,
        'ax-cloak--visible': cloak === false,
        'ax-cloak__container': cloakContainer,
        'ax-container': container
      }, _defineProperty(_classnames, 'ax-hidden-until--' + hiddenUntil, hiddenUntil), _defineProperty(_classnames, 'ax-visible-until--' + visibleUntil, visibleUntil), _defineProperty(_classnames, 'ax-space--' + space, space), _defineProperty(_classnames, 'ax-sticky', sticky), _defineProperty(_classnames, 'ax-text--case-' + textCase, textCase), _defineProperty(_classnames, 'ax-text--align-center', textCenter === true), _defineProperty(_classnames, 'ax-text--align-center--' + textCenter, textCenter && textCenter !== true), _defineProperty(_classnames, 'ax-text--break-' + textBreak, textBreak), _defineProperty(_classnames, 'ax-text--color-' + textColor, textColor), _defineProperty(_classnames, 'ax-text--ellipsis', textEllipsis), _defineProperty(_classnames, 'ax-text--emphasize', textEmphasize), _defineProperty(_classnames, 'ax-text--align-left', textLeft === true), _defineProperty(_classnames, 'ax-text--align-left--' + textLeft, textLeft && textLeft !== true), _defineProperty(_classnames, 'ax-text--align-right', textRight === true), _defineProperty(_classnames, 'ax-text--align-right--' + textRight, textRight && textRight !== true), _defineProperty(_classnames, 'ax-text--size-' + textSize, textSize), _defineProperty(_classnames, 'ax-text--strike', textStrike), _defineProperty(_classnames, 'ax-text--strong', textStrong), _defineProperty(_classnames, 'ax-text--underline-' + underline, underline), _defineProperty(_classnames, 'ax-theme--' + theme, theme), _defineProperty(_classnames, 'ax-pointer--disabled', pointerEventsDisabled), _classnames));

      if (sticky) {
        rest.style = _extends({}, rest.style, {
          top: sticky
        });
      }

      return _react2.default.createElement(Component, _extends({}, rest, { className: classes, ref: baseRef }));
    }
  }]);

  return Base;
}(_react.Component);

Base.propTypes = {
  /**
   * The component that should be rendered with the Base component
   * functionality. If a string is given then it must be a valid
   * React registered element tag.
   */
  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /** Pass this prop to get ref to the Base Component instance. */
  baseRef: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /** Class name to be appended to the element */
  className: _propTypes2.default.string,
  /** Adds ability to make an element invisible */
  cloak: _propTypes2.default.bool,
  /** Adds the ability control the visibility of a child cloaked element */
  cloakContainer: _propTypes2.default.bool,
  /**
   * Controls if a component should be rendered with `position: relative;`
   */
  container: _propTypes2.default.bool,
  /**
   * Control over when the element should be hidden until.
   * Opposite of `visibleUntil`.
   */
  hiddenUntil: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** disables pointer events */
  pointerEventsDisabled: _propTypes2.default.bool,
  /** Vertical margins given to the element */
  space: _propTypes2.default.oneOf(['x0', 'x1', 'x2', 'x3', 'x4', 'x5', 'x6', 'x8']),
  /**
   * Distance from the top of the window where the element shall be stuck
   * to. Utility for "position: sticky;".
   */
  sticky: _propTypes2.default.string,
  /** Text wrap styling */
  textBreak: _propTypes2.default.oneOf(['all', 'none', 'word']),
  /** Text casing styling */
  textCase: _propTypes2.default.oneOf(['capital', 'lower', 'upper']),
  /**
   * Text central alignment either all of the time, with a value of `true`
   * otherwise at one of the breakpoints specified.
   */
  textCenter: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /** Text color styling */
  textColor: _propTypes2.default.oneOf(['body', 'day', 'night', 'error', 'success', 'warning', 'disabled', 'subtle', 'twitter', 'facebook', 'instagram', 'forbidden-planet', 'tiny-clanger', 'critical-mass', 'fantastic-voyage', 'paradise-lost', 'serene-sea', 'event-horizon', 'electric-dreams', 'outer-limits', 'giant-leap', 'moon-lagoon', 'space-invader', 'extraterrestrial', 'terra-form', 'primeval-soup', 'future-shock', 'sun-maker', 'new-horizon', 'blast-off', 'crash-course', 'solar-rust', 'ground-control', 'space-oddity', 'rocky-planet', 'deep-thought', 'luna-dust', 'sentiment-negative', 'sentiment-positive', 'sentiment-neutral', 'ui-accent']),
  /** Text ellipsis styling */
  textEllipsis: _propTypes2.default.bool,
  /** Text emphasis styling */
  textEmphasize: _propTypes2.default.bool,
  /**
   * Text left alignment either all of the time, with a value of `true`
   * otherwise at one of the breakpoints specified.
   */
  textLeft: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /**
   * Text right alignment either all of the time, with a value of `true`
   * otherwise at one of the breakpoints specified.
   */
  textRight: _propTypes2.default.oneOf([true, 'small', 'medium', 'large']),
  /** Text size styling */
  textSize: _propTypes2.default.oneOf(['display2', 'display1', 'headline', 'headtitle', 'large', 'label', 'body', 'small']),
  /** Text strike styling */
  textStrike: _propTypes2.default.bool,
  /** Text bold weight styling */
  textStrong: _propTypes2.default.bool,
  /** Text underlined styling */
  textUnderline: _propTypes2.default.bool,
  /** Theme styling modifier */
  theme: _propTypes2.default.oneOf(['day', 'night']),
  /**
   * Control over when the element should be visible until.
   * Opposite of `hiddenUntil`.
   */
  visibleUntil: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};
Base.defaultProps = {
  Component: 'div'
};
exports.default = Base;